<template>
  <div class="details">
    <breadcrumb></breadcrumb>
    <div class="flex-center">
      <div class="content">
        <div class="title">{{data.title||''}}</div>
        <div class="time" v-if="data.date">发布时间：{{data.date}}</div>
        <div class="file-list" v-if="data.files && data.files.length > 0">
          <div class="file-item" v-for="(file, index) in data.files" :key="index" @click="downloadFile(file)">
            <div class="file-icon">
              <i class="el-icon-document"></i>
            </div>
            <div class="file-info">
              <div class="file-name">{{file.name}}</div>
              <div class="file-size">{{file.size}}</div>
            </div>
            <div class="file-download">
              <i class="el-icon-download"></i>
            </div>
          </div>
        </div>
        <div v-else class="no-file">
          <i class="el-icon-folder-opened"></i>
          <p>暂无可下载文件</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb.vue'

export default {
  components:{
    breadcrumb
  },
  data(){
    return {
      data:{}
    }
  },
  
  created(){
    this.getData()
  },
  methods:{
    getData(){
      const query = this.$route.query
      this.data = {
        title: query.title || '',
        date: query.date || '',
        files: query.files ? JSON.parse(query.files) : []
      }
    },
    downloadFile(file){
      if(file.url){
        window.open(file.url, '_blank')
      }else{
        this.$message.warning('文件链接不存在')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.details{
  padding:0 10%;
  padding-bottom: 109px;
  padding-top: 26px;
  .content{
    width: 56.25%;
    background: #fff6e8;
    padding:64px;
    margin-top:48px;
    min-height: 500px;
    font-size: 20px;
    color: #333333;
    .title{
      font-size: 36px;
      color: #ed9d26;
      font-weight: bold;
      text-align: center;
      margin-bottom: 32px;
    }
    .time{
      font-size: 20px;
      color: #333333;
      margin-bottom: 48px;
      text-align:center;
    }
    .file-list{
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
    .file-item{
      display: flex;
      align-items: center;
      padding: 24px;
      background: #ffffff;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.3s;
      &:hover{
        background: #fff8e6;
        transform: translateX(5px);
      }
      .file-icon{
        width: 60px;
        height: 60px;
        background: #ed9d26;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        i{
          font-size: 30px;
          color: #ffffff;
        }
      }
      .file-info{
        flex: 1;
        .file-name{
          font-size: 20px;
          color: #333333;
          margin-bottom: 8px;
        }
        .file-size{
          font-size: 16px;
          color: #999999;
        }
      }
      .file-download{
        width: 50px;
        height: 50px;
        background: #ed9d26;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        i{
          font-size: 24px;
          color: #ffffff;
        }
      }
    }
    .no-file{
      text-align: center;
      padding: 80px 0;
      color: #999999;
      i{
        font-size: 80px;
        margin-bottom: 20px;
        display: block;
      }
      p{
        font-size: 20px;
      }
    }
  }
}

::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner,
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover{
  color: #303133;
  font-weight: 700;
}
::v-deep .el-breadcrumb__inner a,::v-deep .el-breadcrumb__inner.is-link{
  color: #606266;
  font-weight: 400;
}
</style>
